import React, { FC } from "react"
import { graphql } from "gatsby"

import { TestimonialBlockFragmentFragment } from "@graphqlTypes"

import LpSection from "../LpSection/LpSection"

import TestimonialBlockCarousel from "./components/TestimonialBlockCarousel/TestimonialBlockCarousel"
import TestimonialBlockVanity from "./components/TestimonialBlockVanity/TestimonialBlockVanity"
import TestimonialBlockScroller from "./components/TestimonialBlockScroller/TestimonialBlockScroller"

import "./TestimonialBlock.scss"

export enum TESTIMONIAL_BLOCK_VARIANTS {
  CAROUSEL = "CAROUSEL",
  SCROLLER = "SCROLLER",
  VANITY = "VANITY",
}

const TestimonialBlock: FC<TestimonialBlockFragmentFragment> = ({
  background,
  contentful_id,
  hideAvatars,
  includeBackground,
  includeFeatured,
  items,
  marginBottom,
  text,
  title,
  useDarkMode,
  variant,
}) => {
  const _variant = (!variant || !Object.keys(TESTIMONIAL_BLOCK_VARIANTS).includes(variant)) ?
    TESTIMONIAL_BLOCK_VARIANTS.CAROUSEL :
    variant

  return items ? (
    <LpSection
      background={
        background || (
          (includeBackground && !useDarkMode) ? (
            variant === TESTIMONIAL_BLOCK_VARIANTS.CAROUSEL ?
              "var(--color--slate-200)" :
              "var(--color--slate-100)"
          ) : undefined
        )}
      className={`TestimonialBlock variant--${_variant}`}
      includeBackground={includeBackground}
      marginBottom={_variant === TESTIMONIAL_BLOCK_VARIANTS.CAROUSEL ? "0" : (marginBottom || "XL")}
      text={text}
      title={title}
      uniqueId={contentful_id}
      useDarkMode={useDarkMode}
      useLeftTextAlign={_variant === TESTIMONIAL_BLOCK_VARIANTS.CAROUSEL}
    >
      {_variant === TESTIMONIAL_BLOCK_VARIANTS.CAROUSEL && (
        <TestimonialBlockCarousel
          hideAvatars={hideAvatars}
          items={items}
        />
      )}
      {_variant === TESTIMONIAL_BLOCK_VARIANTS.SCROLLER && (
        <TestimonialBlockScroller
          includeFeatured={includeFeatured}
          items={items}
        />
      )}
      {_variant === TESTIMONIAL_BLOCK_VARIANTS.VANITY && (
        <TestimonialBlockVanity
          hideAvatars={hideAvatars}
          includeBackground={includeBackground}
          items={items}
        />
      )}
    </LpSection>
  ) : null
}

export const TestimonialBlockFragment = graphql`
  fragment TestimonialBlockFragment on ContentfulLpTestimonialBlock {
    contentful_id
    title
    variant: layout
    background
    hideAvatars
    includeBackground
    includeFeatured
    marginBottom
    useDarkMode
    text {
      raw
    }
    items {
      id
      title
      person {
        name
        jobTitle
        company
        image {
          imgixImage {
            gatsbyImageData(width: 80)
            url
          }
        }
      }
      quote {
        raw
      }
      rating
      companyLogo {
        companyName
        logo {
          imgixImage {
            gatsbyImageData(width: 256)
            url
          }
        }
      }
      url: customerStoryUrl
      image: customerStoryImage {
        title
        imgixImage {
          gatsbyImageData(width: 613)
          url
        }
      }
      wistiaId
    }
  }
`

export default TestimonialBlock
